module.exports = __webpack_public_path__ + "static/flags/MU-a8a8e95962267fc7419b355a3913c3f9.gif";